import React from 'react';
import { connect, useSelector } from 'react-redux';

import ConnectListingMapMarker from './connect_listing_map_marker';
import OffMarketMapMarker from './off_market_map_marker';
import { selectOffMarketSearch } from '../../../store/selectors/ui';
import type { AllExclusiveListingResults, AllOffMarketResults } from 'bundles/connect/types';

type MapMarkersProps = {
  allResults: AllExclusiveListingResults[] | AllOffMarketResults[];
}

function MapMarkers({ allResults }: MapMarkersProps) {
  const offMarketSearch = useSelector(selectOffMarketSearch);
  if (offMarketSearch) return (
    <>
      {allResults.map(result => (
        <OffMarketMapMarker
          key={result.propertyId}
          result={result}
        />
      ))}
    </>
  );

  return (
    <>
      {allResults.map(result => (
        <ConnectListingMapMarker
          key={result.saleListingId}
          result={result}
          saleListingId={result.saleListingId}
        />
      ))}
    </>
  );
}

const mapStateToProps = ({ results, ui: { offMarketSearch } }) => {
  const allResults = (offMarketSearch ? results.allOffMarketResults : results.allResults) || [];

  return { allResults, offMarketSearch };
};

export default connect(mapStateToProps)(MapMarkers);
